<template>
  <div>
    <div class="modal" v-show="modalShown">
      <div class="modal-main">
        <div class="title-area">
          <h2>カラー設定</h2>
        </div>
        <div class="input-area">
          <ul>
            <li v-for="(colorMaterial, index) in colorMaterialList" :key="index">
              <label>
                <img class="color-tex" :src="getImg(colorMaterial)" alt="color-tex"/>
                <br>
                <input type="radio" :value="colorMaterial.colorMaterialId" v-model="colorMaterialId">
                {{colorMaterial.colorMaterialName}}
              </label>
            </li>
          </ul>
        </div>
        <div class="button-area">
          <button type="button" class="main_btn" @click="onOk">OK</button>
          <button type="button" class="main_btn" @click="onCancel">キャンセル</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import * as App from '../../../utils/App'

export default {
  name: 'ColorMaterialListModal',
  props: {
    /** ファイルデータ */
    fileData: Object
  },
  data () {
    return {
      /** モーダルの表示フラグ */
      modalShown: false,
      /** デフォルトのカラー設定であるかの判定値 */
      isColorStyleDefault: false,
      /** カラーマテリアルID */
      colorMaterialId: null,
      /** カラーマテリアルのリスト */
      colorMaterialList: [],
      /** カラースタイルグループのindex番号 */
      colorStyleGrpNum: 0
    }
  },
  methods: {
    /** モーダル表示 */
    showModal: function (colorMaterialId, colorMaterialList, isColorStyleDefault, colorStyleGrpNum) {
      this.isColorStyleDefault = isColorStyleDefault
      this.colorMaterialId = colorMaterialId
      this.colorMaterialList = colorMaterialList
      this.colorStyleGrpNum = colorStyleGrpNum
      this.modalShown = true
    },
    getImg: function (colorMaterial) {
      // 表面材がある場合は表面材の画像を返す
      let surfaceMaterialMaster = this.fileData.materialMasterList
        .find(material => material.materialId === colorMaterial.colorMaterialSurface)
      if (surfaceMaterialMaster != null) {
        return this.requireImgPath(surfaceMaterialMaster)
      }

      // 表面材が無かったら芯材の画像を返す
      let boardMaterialMaster = this.fileData.materialMasterList
        .find(material => material.materialId === colorMaterial.colorMaterialBoard)
      return this.requireImgPath(boardMaterialMaster)
    },
    requireImgPath: function (materialMaster) {
      let colorMaster = this.fileData.colorMasterList
        .find(color => color.colorId === materialMaster.materialBaseColorId)
      if (colorMaster) {
        // 原版方向で木目判定
        if (materialMaster.materialGrainDir === 2 && colorMaster.colorDispTexHName) {
          // 横木目
          return this.getImage('tex/' + colorMaster.colorDispTexHName)
        } else {
          // 木目なしもしくは縦目
          return this.getImage('tex/' + colorMaster.colorDispTexVName)
        }
      }
      return this.getImage('noimage.svg')
    },
    onOk: function () {
      /** モーダル非表示 */
      this.modalShown = false
      if (this.isColorStyleDefault) {
        this.$emit('changeColorStyleDefault', this.colorMaterialId)
      } else {
        this.$emit('changeColorStyleGrp', this.colorMaterialId, this.colorStyleGrpNum)
      }
    },
    onCancel: function () {
      this.modalShown = false
    },
    getImage: function (image) {
      return App.getDarosResource(image)
    }
  }
}
</script>
<style scoped>
.modal .modal-main {
  max-width: 765px;
  min-width: 765px;
  max-height: 70%;
}
.modal .modal-main .input-area {
  padding: 10px 10px 10px 10px;
  min-height: 300px;
  margin: 20px auto;
  max-height: 403px;
  overflow-y: auto;
}
.modal .modal-main .input-area ul {
  margin-left: 32px;
}
.modal .modal-main .input-area ul li {
  width: 222px;
  margin-left: 5px;
  margin-right: 5px;
  display: inline-block;
}
.modal .modal-main .input-area ul li .color-tex {
  width: 100px;
  height: 100px;
  margin-left: 12px;
  border: thin solid #000000;
}
</style>



// WEBPACK FOOTER //
// src/main/js/components/planning/modal/ColorMaterialListModal.vue